import styled from "@emotion/styled"
import { getNonUmbracoUrl, Link } from "@eurodrive/utils"
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material"
import ChevronRight from "../../icons/ChevronRight"

const StyledLayout = styled.div`
  display: flex;
  flex-direction: column;
  ${(p) => p.theme.breakpoints.up("md")} {
    display: none;
  }
`

const StyledAccordion = styled(Accordion)<{ index: number }>`
  padding: 0 !important;
  box-shadow: none !important;
  background-color: transparent;
  ::before {
    display: none;
  }
  & path {
    stroke: white;
  }
  &.Mui-expanded {
    margin: 0 !important;
  }
  & .MuiAccordionSummary-root {
    min-height: 0 !important;
    height: 56px;
    border-bottom: 1px solid #aaa !important;
  }
  & .MuiAccordionSummary-content {
    margin: 0 !important;
  }
  & .MuiAccordionSummary-expandIconWrapper.Mui-expanded {
    transform: rotate(90deg);
  }
  & .MuiAccordionDetails-root {
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 24px 16px;
  }
`

const StyledLink = styled(Link)`
  text-decoration: none;
  width: fit-content;
  &:hover {
    box-shadow: inset 0 -1px 0 0 white;
  }
  &:focus-visible {
    border: 1px dashed white;
    outline-offset: 2px;
    outline: 2px solid black;
  }
`

export default function MobileLinks({
  megaMenuItems,
}: {
  megaMenuItems: {
    title: string
    catLinks: { name: string; url: string; type: string }[]
  }[]
}) {
  return (
    <StyledLayout>
      {megaMenuItems.map((item, i) => (
        <StyledAccordion key={i} index={i}>
          <AccordionSummary
            expandIcon={<ChevronRight />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <Typography variant="body2" fontWeight={600}>
              {item.title}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            {item.catLinks.map((el, x) => (
              <StyledLink href={getNonUmbracoUrl(el.url)} key={x}>
                <Typography variant="body2">{el.name}</Typography>
              </StyledLink>
            ))}
          </AccordionDetails>
        </StyledAccordion>
      ))}
    </StyledLayout>
  )
}
